import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["src", "width", "height"]
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  class: /*#__PURE__*/_normalizeClass(`fs14 centered mt5`)
}, "変更", -1)
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", {
  class: /*#__PURE__*/_normalizeClass(`fs14 centered mt5`)
}, "追加", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.mem || _ctx.imageUrl)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onDragover: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.checkDrag($event, 'new', true)), ["prevent"])),
        onDragleave: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.checkDrag($event, 'new', false)), ["prevent"])),
        onDrop: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)), ["prevent"])),
        onMouseover: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showChangeImage && _ctx.showChangeImage(...args))),
        onMouseleave: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.hideChangeImage && _ctx.hideChangeImage(...args))),
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clickImage && _ctx.clickImage(...args)))
      }, [
        (_ctx.hasImage())
          ? _withDirectives((_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.memberIconPath,
              width: _ctx.width,
              height: _ctx.width,
              class: "",
              style: {"margin-top":"0px","border-radius":"50%"}
            }, null, 8, _hoisted_1)), [
              [
                _directive_tooltip,
                _ctx.tooltipString,
                void 0,
                { bottom: true }
              ]
            ])
          : _withDirectives((_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "fw600 pointer centered mc",
              style: _normalizeStyle(`width:${_ctx.width}px;height:${_ctx.width}px;border-radius:50%;margin-top:0px;background-color:#${
                _ctx.mem && _ctx.mem.color ? _ctx.mem.color : `ff8c72`
            };color:#fff;line-height:${_ctx.width}px;font-size:${_ctx.width / 2.5}px`)
            }, [
              _createTextVNode(_toDisplayString(_ctx.mem.name ? _ctx.mem.name[0] : ``), 1)
            ], 4)), [
              [
                _directive_tooltip,
                _ctx.tooltipString,
                void 0,
                { bottom: true }
              ]
            ]),
        (_ctx.canEdit)
          ? (_openBlock(), _createElementBlock("label", {
              key: 2,
              for: "uploadText",
              class: _normalizeClass(`${_ctx.canEdit ? `ChangeImageIcon` : ``} centered pointer blackBg posAb`),
              style: _normalizeStyle(`opacity: 0.8; display: none; height: ${_ctx.width}px; width: ${_ctx.width}px;border-radius: 50%;`)
            }, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/icons/camera_wt.png`),
                width: "33",
                height: "32",
                style: _normalizeStyle(`margin-top: ${_ctx.width / 3 - 8}px;`)
              }, null, 12, _hoisted_2),
              _hoisted_3,
              _hoisted_4
            ], 6))
          : _createCommentVNode("", true)
      ], 32))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        onDragover: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.checkDrag($event, 'new', true)), ["prevent"])),
        onDragleave: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.checkDrag($event, 'new', false)), ["prevent"])),
        onDrop: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)), ["prevent"]))
      }, [
        (_ctx.canEdit)
          ? (_openBlock(), _createElementBlock("label", {
              key: 0,
              for: "uploadText",
              class: "ChangeImageIcon centered pointer blackBg posAb",
              style: _normalizeStyle(`opacity: 0.8; display: block; height: ${_ctx.width}px; width: ${_ctx.width}px;border-radius: 50%;`)
            }, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/icons/camera_wt.png`),
                width: "33",
                height: "32",
                style: _normalizeStyle(`margin-top: ${_ctx.width / 3 - 8}px;`)
              }, null, 12, _hoisted_5),
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("input", {
                type: "file",
                class: "drop__input",
                style: {"display":"none"},
                id: "uploadText",
                onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
              }, null, 32)
            ], 4))
          : _createCommentVNode("", true)
      ], 32))
}